import { Injectable } from '@angular/core';
import { distinctUntilChanged, map, shareReplay, tap } from 'rxjs/operators';
import { SeasonService } from '../season.service';
import { Observable } from 'rxjs';
import { Ranking } from './ranking';

@Injectable({
  providedIn: 'root'
})
export class RankingsService {

  // @TODO Move rankings to separate objects collection in the database.
  rankings$: Observable<Ranking[]> = this.seasonService.activeSeason$.pipe(
    map((season) => JSON.stringify(season.rankings)),
    distinctUntilChanged(),
    map((rankingsString) => JSON.parse(rankingsString)),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor(
    private readonly seasonService: SeasonService
  ) {
  }

  ranking$(id: number | string): Observable<Ranking> {
    return this.rankings$.pipe(
      map((rankings) => rankings.find((ranking) => ranking.id == id)),
      tap((ranking) => {
        if (!ranking) throw new Error('Ranking "' + id + '" not found.')
      }),
      shareReplay({
        refCount: true,
        bufferSize: 1
      })
    );
  }
}
